var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"knowledge_container full flex"},[_c('div',{staticClass:"tinymce"},[_c('tinymce',{attrs:{"menubar":true,"toolbar":_vm.toolbar,"plugins":_vm.plugins},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }